module.exports = __webpack_public_path__ + "img/faxianredbig.713afaa0.svg";